export const theme = {
  primary: "#0f4059",
  primaryInverse: "#ffffff",
};
